<ng-container *ngIf="this.externalSettings">
    <nav [ngStyle]="UIUtilityService.getBankButtonStyle()" id="sidebar" [ngClass]="{'active': isShowingSidebarNav}">
        <div id="sidebarDismiss" class="cursor-pointer item-center" (click)="sidebarDismiss()">
            <mat-icon svgIcon="farAngleDoubleLeft" class="icon-white"></mat-icon>
        </div>

        <div class="mx-2" *ngIf="this.internalSettings">
            <div class="pt-3 pr-5">
                <p class="font-p1w">{{'SI_NAVBAR_WELCOME' | translate}}, {{ StringUtilityService.getCustomerFullName(internalSettings) }}</p>
            </div>
            <div class="d-inline-block">
                <p>{{'LABEL_LAST_LOGIN' | translate}}: {{this.internalSettings.profile.dateAndTimeLastLogin}}</p>
            </div>
            <app-sidebar></app-sidebar>
        </div>
    </nav>
</ng-container>